import yup from '../schemas/_yup'
import { SelectOptions } from '../types'
import { ArraySchema, NumberSchema, StringSchema } from 'yup'
import { MixedSchema } from 'yup/lib/mixed'
import { SchemaField, SchemaInputType } from '../enums'

type YStringSchema = StringSchema<string, any, string>
type YNumberSchema = NumberSchema<number, any, number>
type YArraySchema = ArraySchema<MixedSchema<any, any, any>, any, any[], any[]>
type YMixedSchema = MixedSchema<any, any, any>

export const string: any = yup.string().nullable().default('').trim()

export const number: any = yup.number().nullable().meta({
  field: SchemaField.InputText,
  type: SchemaInputType.number,
})

export const currency: any = string.nullable().meta({
  field: SchemaField.InputCurrency,
  type: SchemaInputType.text,
})

export const text: any = string.nullable().meta({
  field: SchemaField.InputText,
  type: SchemaInputType.text,
})

export const time: any = string.nullable().meta({
  field: SchemaField.InputTimePicker,
  type: SchemaInputType.text,
})

export const textarea: any = string.nullable().meta({
  field: SchemaField.InputText,
  type: SchemaInputType.textarea,
})

export const texteditor: any = string.nullable().meta({
  field: SchemaField.InputTextEditor,
  type: SchemaInputType.texteditor,
})

export const date: any= string.nullable().meta({ field: SchemaField.InputDate })

export const email: any = string
  .meta({ field: SchemaField.InputText, type: SchemaInputType.email })
  .email()
  
export const phone: any =
   string
  .meta({ field: SchemaField.InputPhoneNumber })

export const password: any = string
  .label('Parola')
  .meta({ field: SchemaField.InputPassword, type: SchemaInputType.password })

export const url: any = string.meta({
  field: SchemaField.InputText,
  type: SchemaInputType.url,
})

export const select: any = (options: SelectOptions,type: string | number, entries:[key:string, value:string]): any => {
  const _yup = yup as any;
  return _yup?.[type]().nullable().meta({ field: SchemaField.InputSelect, options, entries })
}

export const autoComplete: any = (options: SelectOptions, type: string | number, entries:[key:string, value:any],  config?:any) => {
  const _yup = yup as any;
  return _yup?.[type]().nullable().meta({ field: SchemaField.InputAutoComplete, options, entries, ...config })
}

export const multipleAutoComplete: any = (options: SelectOptions, entries?:[key:string, value:any], config?:any) => {
  return yup?.array().nullable().meta({ field: SchemaField.InputMultipleAutoComplete, options, entries,...config })
}

export const multipleSelect: any = (options: SelectOptions, entries:[key:string, value:any]) => {
  return yup?.array().nullable().meta({ field: SchemaField.InputMultipleSelect, options, entries })
}

export const inputTabs: any = (data: any, labelName: string, schema) => {
  return yup?.array().of(schema).meta({ field: SchemaField.InputTabs, data, labelName, schema })
}

export const fileBase = yup.mixed().meta({
  field: SchemaField.InputFile,
  type: SchemaInputType.file,
  accept: '*',
})

export const photo = (imagePath?: string,config?: any) => {
  return yup.mixed().meta({
    field: SchemaField.InputFile,
    type: SchemaInputType.file,
    accept: '*',
    imagePath,
    ...config
})}
 

interface Fields {
  url: YStringSchema
  date: YStringSchema
  text: YStringSchema
  time: YStringSchema
  currency: YStringSchema
  email: YStringSchema
  textarea: YStringSchema
  name: YStringSchema
  password: YStringSchema
  select: (options: SelectOptions,type: number | string, entries:[key: string, value: string]) => YStringSchema
  fileBase: YMixedSchema
  autoComplete: (options: SelectOptions, type: string | number, entries: [key: string, value: string],config?:Object) => any
  multipleAutoComplete: (options: SelectOptions, entries?: [key: string, value: string],config?:Object) => any
  multipleSelect: (options: SelectOptions, entries: [key: string, value: string]) => any
  phone: YStringSchema,
  photo: (imagePath?: string, config?:any) => YMixedSchema,
  number: YNumberSchema,
  inputTabs: (data: Array<any>, labelName: string, schema: any) => YMixedSchema
  texteditor: YStringSchema
}

export const fields: Fields = {
  url,
  date,
  text,
  currency,
  email,
  textarea,
  number,
  autoComplete,
  texteditor,
  name: text,
  photo,
  password,
  select,
  fileBase,
  phone,
  multipleSelect,
  inputTabs,
  multipleAutoComplete,
  time,
}
